"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("../util/classnames");
var vdl_prefix_1 = require("../util/vdl-prefix");
var arrow_circle_right_1 = require("adp-react-icons/lib/fa/arrow-circle-right");
var arrow_circle_left_1 = require("adp-react-icons/lib/fa/arrow-circle-left");
var chevron_down_1 = require("adp-react-icons/lib/fa/chevron-down");
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Header.prototype.render = function () {
        var _a = this.props, messages = _a.messages, label = _a.label, labelId = _a.labelId, onMoveRight = _a.onMoveRight, onMoveLeft = _a.onMoveLeft, onViewChange = _a.onViewChange, prevDisabled = _a.prevDisabled, upDisabled = _a.upDisabled, nextDisabled = _a.nextDisabled;
        return (React.createElement("div", { className: vdl_prefix_1.vdlPrefix('calendar__header') },
            React.createElement("button", { className: classnames_1.classNames(vdl_prefix_1.vdlPrefix('calendar__header__button'), vdl_prefix_1.vdlPrefix('calendar__header__button--prev')), tabIndex: -1, onClick: onMoveLeft, disabled: prevDisabled, "aria-disabled": prevDisabled, "aria-label": messages.moveBack, title: messages.moveBack },
                React.createElement(arrow_circle_left_1.default, { "aria-hidden": "false" })),
            React.createElement("button", { id: labelId, tabIndex: -1, className: classnames_1.classNames(vdl_prefix_1.vdlPrefix('calendar__header__button'), vdl_prefix_1.vdlPrefix('calendar__header__button--view')), disabled: upDisabled, "aria-disabled": upDisabled, "aria-live": "polite", "aria-atomic": "true", onClick: onViewChange },
                label,
                React.createElement("span", { className: vdl_prefix_1.vdlPrefix('calendar__header__view-icon') },
                    React.createElement(chevron_down_1.default, null))),
            React.createElement("button", { className: classnames_1.classNames(vdl_prefix_1.vdlPrefix('calendar__header__button'), vdl_prefix_1.vdlPrefix('calendar__header__button--next')), tabIndex: -1, onClick: onMoveRight, disabled: nextDisabled, title: messages.moveForward, "aria-label": messages.moveForward, "aria-disabled": nextDisabled },
                React.createElement(arrow_circle_right_1.default, { "aria-hidden": "false" }))));
    };
    Header.propTypes = {
        label: PropTypes.string.isRequired,
        labelId: PropTypes.string,
        upDisabled: PropTypes.bool.isRequired,
        prevDisabled: PropTypes.bool.isRequired,
        nextDisabled: PropTypes.bool.isRequired,
        onViewChange: PropTypes.func.isRequired,
        onMoveLeft: PropTypes.func.isRequired,
        onMoveRight: PropTypes.func.isRequired,
        messages: PropTypes.shape({
            moveBack: PropTypes.string,
            moveForward: PropTypes.string
        })
    };
    Header.defaultProps = {
        label: '',
        upDisabled: false,
        prevDisabled: false,
        nextDisabled: false,
        onViewChange: function () { },
        onMoveLeft: function () { },
        onMoveRight: function () { }
    };
    return Header;
}(React.PureComponent));
exports.Header = Header;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/calendar/header.js
// module id = 519
// module chunks = 0 1 2 3 4 5 6